//check if language-switcher existes and applies this:
document.querySelectorAll('.language-switcher').forEach((switcher) => {

  //check if there are switcher-buttons and select them
	const buttons = switcher.querySelectorAll('.switcher-button');
	if (!buttons.length) {
		return;
	}

  //get the URL and the Language path of the page
  const pagePath = window.location.pathname.split( '#' )[ 0 ];
  const supportedLangs = [ 'it', 'es', 'en' ];
  const pageLang =
    supportedLangs.find(
      ( lang ) =>
        pagePath === `/${ lang }` ||
        pagePath.includes(`/${ lang }/`)
    ) || 'en';

  //console.log (pagePath);
  //console.log (pageLang);

  //gets every URL (for every language the corresponding page)
  function getLanguageUrl(language) {
    const languageUrl = 
    pagePath.replace(new RegExp(`/${pageLang}(?=/|$)`), `/${language}`);

    //console.log (languageUrl);
    return `${languageUrl}`;
  }

  //assign the href to every corresponding button
  buttons.forEach((button) =>{
    const language = button.dataset.language;
    button.href = getLanguageUrl(language);
    
    //if language switcher corresponds to the page URL
    if (language === pageLang) {

      //deactivates the href and opens the switcher instead when clicked
      button.addEventListener('click', (event) => {
        event.preventDefault();

        openSwitcher();
        //console.log(language);
      });
    }

    //stores the scroll value before changing page
    button.addEventListener('click', () => {
      sessionStorage.setItem('languageSwitcherScrollY', window.scrollY);
    });
  });

  //closes the switcher
	function closeSwitcher() {
    buttons.forEach((button) => {
      const language = button.dataset.language;

      //mantains not hidden just the switcher corresponding to the current page
      if (language === pageLang) {
        button.classList.remove('switcher-hidden');
        button.setAttribute('aria-current', 'true');
      } else {
        button.classList.add('switcher-hidden');
        button.removeAttribute('aria-current');
      }
    });

    //removes the open class from language switcher
    switcher.classList.remove('open');
  }

  //opens the switcher
  function openSwitcher() {

    //removes the class switcher-hidden from every switcher button
    buttons.forEach((button) => {
      button.classList.remove('switcher-hidden');
    });

    //sets the language-switcher class to open
    switcher.classList.add('open');
  }

  //every click in the document checks if the switcher is opened and eventually closes it
  document.addEventListener('click', (event) => {
    const isOpen = switcher.classList.contains('open');

    if (isOpen && !switcher.contains(event.target)) {
      closeSwitcher();
    }
  });

  //closes the switcher by default when rendering the page first
  closeSwitcher();
});